import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material'
import styled from 'styled-components'

export type TabPropsType = MuiTabProps

const Tab = styled(MuiTab)<TabPropsType>``

export default Tab
